import * as React from "react"
import { useInView, type UseInViewOptions } from "motion/react"

interface UseIsInViewOptions {
	inView?: boolean
	inViewOnce?: boolean
	inViewMargin?: UseInViewOptions["margin"]
}

function useIsInView<T extends HTMLElement = HTMLElement>(
	options: UseIsInViewOptions = {},
) {
	const { inView, inViewOnce = false, inViewMargin = "0px" } = options
	const localRef = React.useRef<T>(null)

	const inViewResult = useInView(localRef, {
		once: inViewOnce,
		margin: inViewMargin,
	})

	// If inView is false (default), isInView is always true, effectively disabling the intersection observer logic.
	// If inView is true, isInView depends on the actual intersection observer result.
	const isInView = !inView || inViewResult
	return { ref: localRef, isInView }
}

export { useIsInView, type UseIsInViewOptions }
